var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.stockClass,staticStyle:{"z-index":"1"},attrs:{"title":_vm.stockText}})}
var staticRenderFns = []

export { render, staticRenderFns }